<script setup>
import { computed } from "vue";
import { useStore } from "vuex";
import SidenavList from "./SidenavList.vue";
import NexaLogo from "@/components/NexaLogo.vue";

const store = useStore();
const isRTL = computed(() => store.state.isRTL);
const layout = computed(() => store.state.layout);
const sidebarType = computed(() => store.state.sidebarType);
const darkMode = computed(() => store.state.darkMode);
const isPinned = computed(() => store.state.isPinned);

// Por debajo del breakpoint xl, "pinned" significa "abierto sobre el
// contenido" (ver _navbar-vertical.scss, media-breakpoint-down(xl)) -- cerrar
// el menú móvil es simplemente volver a des-pinnearlo. El cierre automático
// al navegar ya lo hace cada SidenavItem (minimizeSidebar en su @click).
function cerrarMenuMovil() {
  if (isPinned.value) store.commit("sidebarMinimize");
}
</script>
<template>
  <div v-show="layout === 'default'" class="min-height-300 position-absolute w-100"
    :class="`${darkMode ? 'bg-transparent' : 'bg-primary'}`" />

  <div class="sidenav-backdrop d-xl-none" :class="{ show: isPinned }" @click="cerrarMenuMovil"></div>

  <aside class="my-3 overflow-auto border-0 sidenav navbar navbar-vertical navbar-expand-xs border-radius-xl" :class="`${isRTL ? 'me-3 rotate-caret fixed-end' : 'fixed-start ms-3'}
      ${layout === 'landing' ? 'bg-transparent shadow-none' : ' '
    } ${sidebarType}`" id="sidenav-main">
    <div class="sidenav-header">
      <i class="top-0 p-3 cursor-pointer fas fa-times text-secondary opacity-5 position-absolute end-0 d-xl-none"
        aria-hidden="true" id="iconSidenav" @click="cerrarMenuMovil"></i>

      <router-link class="m-0 navbar-brand" to="/">
        <nexa-logo :light="darkMode || sidebarType === 'bg-default'" />
      </router-link>
    </div>

    <hr class="mt-0 horizontal dark" />

    <sidenav-list />
  </aside>
</template>

<style scoped>
.sidenav-backdrop {
  display: none;
}

@media (max-width: 1199.98px) {
  .sidenav-backdrop.show {
    display: block;
    position: fixed;
    inset: 0;
    background: rgba(11, 11, 24, 0.5);
    z-index: 1020;
    animation: sidenav-backdrop-fade 0.2s ease;
  }
}

@keyframes sidenav-backdrop-fade {
  from { opacity: 0; }
  to { opacity: 1; }
}
</style>
